import React, { memo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { CalendarHeaderContainer } from '../MonthlyShiftSlotSetup.styles';

interface CalendarHeaderProps {
  year: number;
  month: number;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
  disabled?: boolean;
}

/**
 * カレンダーヘッダーコンポーネント
 *
 * - 年月表示
 * - 前月・次月ボタン
 */
const CalendarHeader: React.FC<CalendarHeaderProps> = memo(({
  year,
  month,
  onPreviousMonth,
  onNextMonth,
  disabled = false,
}) => {
  return (
    <CalendarHeaderContainer>
      <IconButton
        onClick={onPreviousMonth}
        disabled={disabled}
        size="small"
      >
        <ChevronLeftIcon />
      </IconButton>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" fontWeight={600}>
          {year}年 {month}月
        </Typography>
      </Box>
      <IconButton
        onClick={onNextMonth}
        disabled={disabled}
        size="small"
      >
        <ChevronRightIcon />
      </IconButton>
    </CalendarHeaderContainer>
  );
});

CalendarHeader.displayName = 'CalendarHeader';

export default CalendarHeader;
